import React from "react";
import styled from "styled-components";
import { Link } from "gatsby";

export default () => {
    return (
        <MenuWrapper className="menu-wrap">
            <input aria-label="Toggle hamburger menu" type="checkbox" className="toggler" />
            <div className="hamburger">
                <div></div>
            </div>
            <div className="menu">
                <div>
                    <div>
                        <ul>
                            <li>
                                <Link aria-label="Home" to="/">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link aria-label="About" to="/about/">
                                    About
                                </Link>
                            </li>
                            <li>
                                <Link aria-label="Contact" to="/contact/">
                                    Contact
                                </Link>
                            </li>
                            <li>
                                <a aria-label="Braden's cell phone number" href="tel:+18019600166">
                                    (801) 960-0166
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </MenuWrapper>
    );
};

const MenuWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    z-index: 3;

    .toggler {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 3;
        cursor: pointer;
        width: 50px;
        height: 50px;
        opacity: 0;

        &:checked {
            + .hamburger {
                > div {
                    &:before,
                    &:after {
                        top: 0;
                        transform: rotate(90deg);
                    }
                }
            }

            ~ .menu {
                visibility: visible;
                div {
                    transform: scale(1);
                    transition-duration: 0.75s;
                    div {
                        opacity: 1;
                        transition: opacity 0.4s ease 0.4s;
                    }
                }
            }
        }

        &:checked + .hamburger > div {
            transform: rotate(135deg);
        }

        &:checked:hover + .hamburger {
            div {
                transform: rotate(225deg);
            }
        }
    }

    .hamburger {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
        width: 50px;
        height: 50px;
        padding: 1rem;
        background: ${({ theme }) => theme.colorSecondary};
        border-radius: 0px 0px 0px 5px;
        display: flex;
        align-items: center;
        justify-content: center;

        > div {
            position: relative;
            flex: none;
            width: 100%;
            height: 2px;
            background: rgb(24, 29, 51);
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.4s ease;

            &:after,
            &:before {
                content: "";
                position: absolute;
                z-index: 2;
                top: -10px;
                width: 100%;
                height: 2px;
                background: inherit;
            }

            &:after {
                top: 10px;
            }
        }
    }

    .menu {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        visibility: hidden;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        > div {
            background: ${({ theme }) => theme.hamburgerMenuBackground};
            border-radius: 5%;
            width: 200vw;
            height: 100%;
            display: flex;
            flex: none;
            align-items: center;
            justify-content: center;
            transform: scale(0);
            transition: all 0.4s ease;

            div {
                text-align: center;
                max-width: 90vw;
                max-height: 100vh;
                opacity: 0;
                transition: opacity 0.4s ease;
                ul {
                    li {
                        list-style: none;
                        color: #fff;
                        font-size: 1.5rem;
                        padding: 1rem;
                        a {
                            color: ${({ theme }) => theme.colorPrimary};
                            font-family: Raleway, Serif;
                            text-decoration: none;
                            background-image: none;
                            text-shadow: none;
                            transition: color 0.4s ease;
                            font-size: 3.5rem;

                            &:hover {
                                opacity: 0.5;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
    }

    @media only screen and (min-width: 801px) {
        display: none;
    }
`;
